//#region IMPORTS
import { TruckIcon } from "@heroicons/react/24/outline";
import { InstoreOrder } from "../../models/instoreOrder";
import { Fragment } from "react";
import { Tooltip } from "react-tooltip";
//#endregion

//#region INTERFACE
interface Props {
  shipHandler: () => void;
  hide?: boolean;
  instoreOrder: InstoreOrder;
}
//#endregion

export default function InstoreOrdersTableRowActionShip({
  shipHandler,
  instoreOrder,
  hide = false,
}: Props) {
  return !hide ? (
    <Fragment>
      <button
        data-tooltip-content="Ship order?"
        data-tooltip-variant="dark"
        data-tooltip-place="left"
        data-tooltip-id={String(instoreOrder.id) + "ship"}
        data-tooltip-delay-show={500}
        className="flex items-center gap-4"
      >
        <TruckIcon
          className="h-4 w-4 text-sky-700 hover:cursor-pointer hover:text-sky-500"
          onClick={shipHandler}
          type="button"
        />
      </button>
      <Tooltip id={String(instoreOrder.id) + "ship"} />
    </Fragment>
  ) : null;
}
